import Module from "./Module.vue";

import SettlementEdcGlobalList from "./views/SettlementEdcGlobalList"
import Transaksi from "@/modules/penghapusan-transaksi/reguler/views/Transaksi";

const modalExport = () => {
	return import('./components/SOExportModal.vue');
}

const requireAuth = {requireAuth: true};

const moduleRoute = {
	path: "/settlement-edc-global",
	component: Module,
	children: [
		{
			path: "",
			name: "SettlementEdcGlobal",
			component: SettlementEdcGlobalList,
			meta: {
				...requireAuth,
				accessKey: 'settlement.read',
			},
		},
		{
			path: 'export',
			name: 'SettlementEdcGlobal.export',
			components: {
				default: SettlementEdcGlobalList,
				dialog: modalExport
			},
			meta: {requireAuth: true},
		},
	]
}

export default (router) => {
	router.addRoutes([moduleRoute]);
};